var LODOP; //声明为全局变量
var intervalId;
var ids;
var array = new Array();
var printTimes = 0;
var preTimes = 0;
var length = 0;
var pkId;
var basis=null;

$('body').mLoading({text:"生成标签数据，请稍等..."});
//$('body').mLoading("show");

$(window).load(function () {

  pkId = getQueryString("pkId");
  // var url = "http://10.67.11.222:8080/ncp/agriculture/producepackage/printPKGTag.action?pkId=" + pkId; //测试服务器
  var url = "https://www.grncp.cn/ncp/agriculture/producepackage/printPKGTag.action?pkId=" + pkId; //正式服务器
  
  $.ajax({
    url:url,
    type:'get',
    async:false,//使用同步的方式
    success:function(rtObj){
      var rtdata=JSON.parse(rtObj);
      console.log('返回数据：'+JSON.stringify(rtdata));
      ids = rtdata.ids;
      array = rtdata.dataList;
	  var str1 = array[1].replace("yzf.com","cp.cn")
	  var str2 = array[16].replace("yzf.com","cp.cn")
	  
	  array.splice(1,1,str1)
	  array.splice(16,1,str2)
	  
      console.log(array)
	  length = ids.length; //标签个数
    },
    fail:function(){
      console.log("生成标签接口调用失败");
    }
  });
  $('body').mLoading("hide");

  LODOP = getLodop();

  var priterCount = LODOP.GET_PRINTER_COUNT();
  for (var i = 0; i < priterCount; i++) {
    $("#printers").append('<option value="' + i + '">' + LODOP.GET_PRINTER_NAME(i) + '</option>');
  }
});

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

$("#printButton").click(function () {
  basis=$('input:radio[name=basis]:checked').val();

  if(basis==null || basis==''){
    alert('请选择承诺依据！');
    return false;
  }

  LODOP.SET_PRINT_STYLEA(0,"QRCodeVersion",5);
  LODOP.SET_PRINT_STYLEA(0,"QRCodeErrorLevel","L");
  //console.log('ids:'+ids);
  if(!ids || ids.length==0){
    alert('未生成标签，无法打印！');
    return false;
  }
  
  $('body').mLoading({text:"打印中，请稍等..."});
	//===============================
	$.ajax({
		// url:'http://10.67.11.222:8080/ncp/agriculture/producepackage/saveBatchPrintlabelCode.action',
    url:'https://www.grncp.cn/ncp/agriculture/producepackage/saveBatchPrintlabelCode.action',
		type:'post',
		async:false,//使用同步的方式
		data:{"pkId":pkId,"ids":ids.join(',')},
		success:function(rtObj){
			var rtdata=JSON.parse(JSON.parse(rtObj));//eval('(' + rtObj + ')');
			//console.log(rtdata.key);
			//console.log(typeof(rtdata));
			if (rtdata.success) {
				console.log('Save lable code success!');
			} else {
				console.log('Save lable code fail!');
			}
		},
		fail:function(){
			console.log("批量打印接口调用失败");
		}
  });
  
  //把包装的id放到最后，最后一个打印存根使用
  ids.push(pkId);
  length=length+1;
  console.log('ids:'+ids);
	//===============================
	
  var printerName = $("#printers option:selected").text();
  //打印机类型
  var printType = '0';
  if (printerName.indexOf("POSTEK E58") != -1) {
    printType = '1';
  } else if (printerName.indexOf("POSTEK C168") != -1) {
    printType = '2';
  } else {
    printType = '2';
  }

  var webSiteRoot="https://www.grncp.cn";
  var QRCodeUrl = "http://www.grncp.cn/g/";//农产品标签二维码地址
  var lableUrl = "http://www.grncp.cn/p/";//用包装id查询已打印标签（存根）

  // var QRCodeUrl = "http://10.67.11.222:8080/grny_cms/g/";
  // var lableUrl = "http://10.67.11.222:8080/grny_cms/p/";
  // var webSiteRoot="http://10.67.11.222:8080";

  var lableCols = $("#lableCols").val(); //获取单行标签列数
  var printStyle = 'old';
  if(lableCols==-1){
    lableCols=1;
    printStyle = 'new'
  }
  preTimes = Math.ceil(length / lableCols); //预计打印次数

  if (lableCols == 8) {
    var QRLength = 30;
    var top = 8;
    var left = 18;
    for (var i = 0; i < length;) {
      //设置纸张大小
      LODOP.SET_PRINT_PAGESIZE(1, 960, 100, "strPageName");
      LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1);
      LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);
      //设置第一列内容
      var spacing = 45;
      var left = 8;
      var top = 8;
      //设置POSTEK C168的Y轴起点
      if (printType == '2') {
        top = 4;
      }
      var QRCodeLeft;
      var offset = 0;
      for (var j = 0; j < 8; j++) {
        //每隔三个标签，增加一个偏移量
        if (j % 3 == 0) {
          offset++;
        }
        //设定二维码的X轴起点
        QRCodeLeft = left + spacing * j + offset;
        console.log('数组：'+ids);
        if (i < length) {
          //画出矩形标记标签边界
          //  LODOP.ADD_PRINT_RECT(6, 6+spacing*j+offset, 37, 37,0, 1);
          if(i==length-1){
            //打印存根
            //LODOP.ADD_PRINT_TEXT(2, QRCodeLeft-10, 15, 5, '存根'); 
            LODOP.ADD_PRINT_BARCODE(top-2, QRCodeLeft-4, QRLength, QRLength, "QRCode", lableUrl + ids[i]);
			
          }else{
            //正常打印标签
            //设置二维码
            LODOP.ADD_PRINT_BARCODE(top+1, QRCodeLeft-1, QRLength, QRLength, "QRCode", QRCodeUrl + ids[i]);
          }
          i++;
        } else {
          break;
        }
      }

      print();
    }
  } else if (lableCols == 3) {
    for (var i = 0; i < length;) {
      //设置纸张大小
      //LODOP.SET_PRINT_PAGESIZE(1, 790, 200, "strPageName");
      LODOP.SET_PRINT_PAGESIZE(1, 680, 200, "strPageName");
      LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1);
      LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);

      //打印存根
      if(i==length-1){
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 4);
        LODOP.ADD_PRINT_TEXT(2, 22, 40, 10, '存根'); 
        //LODOP.ADD_PRINT_BARCODE(10, 15, 70, 70, "QRCode", lableUrl + ids[i]);
        LODOP.ADD_PRINT_IMAGE(1, 10, 70, 70,"<img border='0' width='70' height='70' src='"+ webSiteRoot +"/grny_app/showQrCode?width=70&height=70&text="+lableUrl + ids[i]+"'/>");
		
        i++;
      }

      //设置第一列内容
      //LODOP.ADD_PRINT_BARCODE(10, 15, 70, 70, "QRCode", QRCodeUrl + ids[i]);
      LODOP.ADD_PRINT_IMAGE(1, 10, 70, 70,"<img border='0' width='70' height='70' src='"+ webSiteRoot +"/grny_app/showQrCode?width=70&height=70&text="+QRCodeUrl + ids[i]+"'/>");
      i++;

      //打印存根
      if(i==length-1){
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 4);
        LODOP.ADD_PRINT_TEXT(2, 132, 40, 10, '存根'); 
        //LODOP.ADD_PRINT_BARCODE(10, 122, 70, 70, "QRCode", lableUrl + ids[i]);
        LODOP.ADD_PRINT_IMAGE(1, 95, 70, 70,"<img border='0' width='70' height='70' src='"+ webSiteRoot +"/grny_app/showQrCode?width=70&height=70&text="+lableUrl + ids[i]+"'/>");
		
        i++;
      }

      if (i < length) {
        //设置第二列内容
        //LODOP.ADD_PRINT_BARCODE(10, 122, 70, 70, "QRCode", QRCodeUrl + ids[i]);
        LODOP.ADD_PRINT_IMAGE(1, 95, 70, 70,"<img border='0' width='70' height='70' src='"+ webSiteRoot +"/grny_app/showQrCode?width=70&height=70&text="+QRCodeUrl + ids[i]+"'/>");
        i++;
      }

      //打印存根
      if(i==length-1){
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 4);
        LODOP.ADD_PRINT_TEXT(2, 232, 40, 10, '存根'); 
        //LODOP.ADD_PRINT_BARCODE(10, 222, 70, 70, "QRCode", lableUrl + ids[i]);
        LODOP.ADD_PRINT_IMAGE(1, 177, 70, 70,"<img border='0' width='70' height='70' src='"+ webSiteRoot +"/grny_app/showQrCode?width=70&height=70&text="+lableUrl + ids[i]+"'/>");
		
        i++;
      }

      if (i < length) {
        //设置第三列内容
        //LODOP.ADD_PRINT_BARCODE(10, 222, 70, 70, "QRCode", QRCodeUrl + ids[i]);
        LODOP.ADD_PRINT_IMAGE(1, 177, 70, 70,"<img border='0' width='70' height='70' src='"+ webSiteRoot +"/grny_app/showQrCode?width=70&height=70&text="+QRCodeUrl + ids[i]+"'/>");
        i++;
      }

      print();
    }
  } else if (lableCols == 2) {
    var top = 10;
    var left1 = 5; //两列标签第一列起点
    var left1Title = left1 + 20; //两列标签第一列标题的起点
    var left2 = 200; //两列标签第二列起点
    var left2Title = left2 + 20; //两列标签第二列标题的起点

    var maxWidth = 170; //单列最大宽度
    var maxHeight = 120; //单列最大宽度

    var rowSpacing = 20; //行间距
    var QRCodeTop = 65; //二维码定点
    var QRCodeLength = 70; //二维码长度（宽和高）
    var QRCodeLeft1 = left1 + maxWidth + 10 - QRCodeLength; //第一列二维码X轴起点
    var QRCodeLeft2 = left2 + maxWidth + 10 - QRCodeLength; //第一列二维码X轴起点
    for (var i = 0; i < length;) {

      LODOP.SET_PRINT_PAGESIZE(1, 1020, 350, "strPageName"); //设置纸张大小
      LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1); //设置非逐项打印
      //  LODOP.SET_PRINT_MODE("POS_BASEON_PAPER",true);//设置输出以纸张边缘为基点

      //以下内容画矩形，用以标注标签范围，便于软件开发
      //ADD_PRINT_RECT(Top, Left, Width, Height,intLineStyle, intLineWidth)
      //  LODOP.ADD_PRINT_RECT(top, left1, maxWidth, maxHeight,0, 1);//标注第一列标签范围
      //  LODOP.ADD_PRINT_RECT(top, left2, maxWidth, maxHeight,0, 1);//标注第二列标签范围
      //  LODOP.ADD_PRINT_RECT(top,left1+20,maxWidth-40,rowSpacing,0, 3);//标注第一列标题及单行高度
      //  LODOP.ADD_PRINT_RECT(top,left2+20,maxWidth-40,rowSpacing,0, 3);//标注第二列标题及单行高度

      //打印存根
      if(i==length-1){
        /* LODOP.SET_PRINT_STYLEA(0, "FontSize", 4);
        LODOP.ADD_PRINT_TEXT(top, left1, maxWidth, rowSpacing, '存根'); 
        LODOP.ADD_PRINT_BARCODE(top + rowSpacing * 2, left1, QRCodeLength, QRCodeLength, "QRCode", lableUrl + ids[i]);
        i++; */

        LODOP.ADD_PRINT_TEXT(top, left1Title, maxWidth, rowSpacing, array[0]+'（存根）'); //title
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 1, left1, maxWidth, rowSpacing, array[4]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 2, left1, maxWidth, rowSpacing, array[15]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 3, left1, maxWidth, rowSpacing, "采摘:" + array[13]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 4, left1, maxWidth, rowSpacing, "包装:" + array[8]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 5, left1, maxWidth, rowSpacing, "保质期：" + array[9] + "天");
        // 二维码格式 - ADD_PRINT_BARCODE(Top, Left,Width, Height, CodeType, CodeValue)
        LODOP.ADD_PRINT_BARCODE(QRCodeTop, QRCodeLeft1, QRCodeLength, QRCodeLength, "QRCode", lableUrl + ids[i]);
		
        i++;
      }else{
        /*
        * 设置第一列内容
        */
        // 文本格式 - ADD_PRINT_TEXT(Top,Left,Width,Height,strContent)
        LODOP.ADD_PRINT_TEXT(top, left1Title, maxWidth, rowSpacing, array[0]); //title
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 1, left1, maxWidth, rowSpacing, array[4]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 2, left1, maxWidth, rowSpacing, array[15]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 3, left1, maxWidth, rowSpacing, "采摘:" + array[13]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 4, left1, maxWidth, rowSpacing, "包装:" + array[8]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 5, left1, maxWidth, rowSpacing, "保质期：" + array[9] + "天");
        // 二维码格式 - ADD_PRINT_BARCODE(Top, Left,Width, Height, CodeType, CodeValue)
        LODOP.ADD_PRINT_BARCODE(QRCodeTop, QRCodeLeft1, QRCodeLength, QRCodeLength, "QRCode", QRCodeUrl + ids[i]);
        i++;
      }

      //打印存根
      if(i==length-1){
        /* LODOP.ADD_PRINT_TEXT(top, left2+20, maxWidth, rowSpacing, '存根'); 
        LODOP.ADD_PRINT_BARCODE(top + rowSpacing * 2, left2+20, QRCodeLength, QRCodeLength, "QRCode", lableUrl + ids[i]);
        i++; */

        LODOP.ADD_PRINT_TEXT(top, left2Title, maxWidth, rowSpacing, array[0]+'（存根）'); //title
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 1, left2, maxWidth, rowSpacing, array[4]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 2, left2, maxWidth, rowSpacing, array[15]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 3, left2, maxWidth, rowSpacing, "采摘:" + array[13]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 4, left2, maxWidth, rowSpacing, "包装:" + array[8]);
        LODOP.ADD_PRINT_TEXT(top + rowSpacing * 5, left2, maxWidth, rowSpacing, "保质期：" + array[9] + "天");
        LODOP.ADD_PRINT_BARCODE(QRCodeTop, QRCodeLeft2, QRCodeLength, QRCodeLength, "QRCode", lableUrl + ids[i]);
		
        i++;
      }else{
        if (i < length) {
          /*
          * 设置第二列内容
          */
          LODOP.ADD_PRINT_TEXT(top, left2Title, maxWidth, rowSpacing, array[0]); //title
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 1, left2, maxWidth, rowSpacing, array[4]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 2, left2, maxWidth, rowSpacing, array[15]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 3, left2, maxWidth, rowSpacing, "采摘:" + array[13]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 4, left2, maxWidth, rowSpacing, "包装:" + array[8]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 5, left2, maxWidth, rowSpacing, "保质期：" + array[9] + "天");
          LODOP.ADD_PRINT_BARCODE(QRCodeTop, QRCodeLeft2, QRCodeLength, QRCodeLength, "QRCode", QRCodeUrl + ids[i]);
          i++;
        }
      }

      /*
       * 打印
       */
      print();
    }
  } else {
    var top = 30;
    var left = 55; //两列标签第一列起点
    var leftTitle = left + 70; //两列标签第一列标题的起点

    var maxWidth = 330; //单列最大宽度
    var maxHeight = 240; //单列最大宽度
    var fontWidth = 260;//文本最大宽度
    var rowSpacing = 10; //行间距
    var QRCodeTop = 90; //二维码定点
    var QRCodeLength = 95; //二维码长度（宽和高）
    var QRCodeLeft = left + maxWidth - QRCodeLength - 30; //二维码X轴起点

    var BARLeft = QRCodeLeft;
    var BARType = "";
    if (printType == '1') {
      BARType = "EAN128C";
      BARLeft = 242;
    } else {
      BARType = "128A";
    }

    var BARHeight = 26;//条形码高度
    var BARTop = QRCodeTop + QRCodeLength + 3;
    var BARWidth = 100;

    if(printStyle=='new'){

      for (var i = 0; i < length;) {
        LODOP.SET_PRINT_PAGESIZE(1, 990, 700, "strPageName"); //设置纸张大小
        LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1); //设置非逐项打印
        LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true); //设置输出以纸张边缘为基点
        
        if(i==length-1){
          /* LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 1, left+20, fontWidth, rowSpacing, "存根");
          LODOP.ADD_PRINT_BARCODE(top + (rowSpacing+3) * 2, left+20, 92, 92, "QRCode", lableUrl + ids[i]);
          i++; */
          
          LODOP.SET_PRINT_STYLE("FontSize", 8); //设置打印字体
          //LODOP.SET_PRINT_STYLE("FontName","仿宋"); //设置打印字体
          LODOP.SET_PRINT_STYLE("Bold", 1); //设置打印字体

          LODOP.ADD_PRINT_TEXT(top - 10, leftTitle-10, fontWidth, rowSpacing, '承诺达标合格证（存根）'); //title
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10); //设置打印字体
      
          LODOP.SET_PRINT_STYLE("FontSize", 7); 
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 1, left, fontWidth, rowSpacing, '我承诺对生产销售的食用农产品：');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 2, left, fontWidth, rowSpacing, '☑不使用禁用农药兽药、停用兽药和非法添加物');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 3, left, fontWidth, rowSpacing, '☑常规农药兽药残留不超标');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 4, left, fontWidth, rowSpacing, '☑对承诺的真实性负责');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 5, left, fontWidth, rowSpacing, '承诺依据：');
          if(basis=='weituojiance'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '☑委托检测        □自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '□内部质量控制     □自我承诺');
          }else if(basis=='ziwojiance'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '□委托检测        ☑自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '□内部质量控制     □自我承诺');
          }else if(basis=='neibukongzhi'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '□委托检测        □自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '☑内部质量控制     □自我承诺');
          }else if(basis=='ziwochengnuo'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '□委托检测        □自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '□内部质量控制     ☑自我承诺');
          }
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 8, left, fontWidth, rowSpacing, '—— —— —— —— —— —— —— —— —— —— —— ——');

          //LODOP.SET_PRINT_STYLE("FontSize", 8); 
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 9, left, fontWidth, rowSpacing, "产品名称：" + array[4]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 9, left+170, fontWidth, rowSpacing, "数量（重量）：" + printStr(array[17]));
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 10, left, fontWidth, rowSpacing, "产地：" + array[12]);//公司地址
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 11, left, fontWidth, rowSpacing, "生产者盖章或签名：");
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 12, left, fontWidth, rowSpacing, "联系方式：" + array[11]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 13, left, fontWidth, rowSpacing, "开具日期：" + array[8]);

          //if(!isBlankStr(array[16])){
            LODOP.ADD_PRINT_IMAGE(top + (rowSpacing+3) * 10+10, left+150,100,70,"<img border='0' width='70' height='auto' src='"+array[16]+"' />");
          //}
          LODOP.ADD_PRINT_IMAGE(top + (rowSpacing+3) * 10, left+230, 80, 80,"<img border='0' width='80' height='80' src='https://www.grncp.cn/grny_app/showQrCode?text="+lableUrl + ids[i]+"'/>");
		  
          i++;
        }else{
          LODOP.SET_PRINT_STYLE("FontSize", 8); //设置打印字体
          //LODOP.SET_PRINT_STYLE("FontName","仿宋"); //设置打印字体
          LODOP.SET_PRINT_STYLE("Bold", 1); //设置打印字体

          LODOP.ADD_PRINT_TEXT(top - 10, leftTitle, fontWidth, rowSpacing, '承诺达标合格证'); //title
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10); //设置打印字体

          
      
          LODOP.SET_PRINT_STYLE("FontSize", 7); 
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 1, left, fontWidth, rowSpacing, '我承诺对生产销售的食用农产品：');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 2, left, fontWidth, rowSpacing, '☑不使用禁用农药兽药、停用兽药和非法添加物');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 3, left, fontWidth, rowSpacing, '☑常规农药兽药残留不超标');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 4, left, fontWidth, rowSpacing, '☑对承诺的真实性负责');
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 5, left, fontWidth, rowSpacing, '承诺依据：');
          if(basis=='weituojiance'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '☑委托检测        □自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '□内部质量控制     □自我承诺');
          }else if(basis=='ziwojiance'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '□委托检测        ☑自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '□内部质量控制     □自我承诺');
          }else if(basis=='neibukongzhi'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '□委托检测        □自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '☑内部质量控制     □自我承诺');
          }else if(basis=='ziwochengnuo'){
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, '□委托检测        □自我检测');
            LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, '□内部质量控制     ☑自我承诺');
          }
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 8, left, fontWidth, rowSpacing, '—— —— —— —— —— —— —— —— —— —— —— ——');

          //LODOP.SET_PRINT_STYLE("FontSize", 8); 
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 9, left, fontWidth, rowSpacing, "产品名称：" + array[4]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 9, left+170, fontWidth, rowSpacing, "数量（重量）：" + printStr(array[14]));
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 10, left, fontWidth, rowSpacing, "产地：" + array[12]);//公司地址
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 11, left, fontWidth, rowSpacing, "生产者盖章或签名：");
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 12, left, fontWidth, rowSpacing, "联系方式：" + array[11]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 13, left, fontWidth, rowSpacing, "开具日期：" + array[8]);
          //if(!isBlankStr(array[16])){
            LODOP.ADD_PRINT_IMAGE(top + (rowSpacing+3) * 10+10, left+150,100,70,"<img border='0' width='70' height='auto' src='"+array[16]+"' />");
          //}
          LODOP.ADD_PRINT_IMAGE(top + (rowSpacing+3) * 10, left+230, 60, 60,"<img border='0' width='60' height='60' src='https://www.grncp.cn/grny_app/showQrCode?text="+QRCodeUrl + ids[i]+"'/>");
      
          /*
          //把盖章签名拿到上面来
          if(!isBlankStr(array[16])){
            //LODOP.ADD_PRINT_IMAGE(top + (rowSpacing+3) * 4, left+150,60,60,"<img border='0' width='65' height='auto' src='"+array[16]+"' />");
            LODOP.ADD_PRINT_IMAGE(top + (rowSpacing+3) * 4+10, left+150,100,70,"<img border='0' width='70' height='auto' src='"+array[16]+"' />");
          }

          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 1, left, fontWidth, rowSpacing, "产品名称：" + array[4]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 1, left+170, fontWidth, rowSpacing, "数量（重量）：" + printStr(array[14]));
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 2, left, fontWidth, rowSpacing, "保质期：" + array[9] + "天");
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 2, left+170, fontWidth, rowSpacing, "检测结果："+array[18]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 3, left, fontWidth, rowSpacing, "生产者：" + array[10]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 4, left, fontWidth, rowSpacing, "产地：" + array[12]);//公司地址
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 5, left, fontWidth, rowSpacing, "联系方式：" + array[11]);
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 6, left, fontWidth, rowSpacing, "开具日期：" + array[8]);
          
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 7, left, fontWidth, rowSpacing, "生产者盖章或签名：");
          
          //LODOP.ADD_PRINT_BARCODE(top + (rowSpacing+3) * 8, left, 80, 80, "QRCode", QRCodeUrl + ids[i]);//二维码
          LODOP.ADD_PRINT_IMAGE(top + (rowSpacing+3) * 8-2, left-5, 55, 55,"<img border='0' width='55' height='55' src='https://www.grncp.cn/grny_app/showQrCode?text="+QRCodeUrl + ids[i]+"'/>");
          LODOP.SET_PRINT_STYLE("FontSize", 7); //设置打印字体
          LODOP.ADD_PRINT_TEXT(top + (rowSpacing+3) * 8, left+60, fontWidth-10, 100, note);
          */
          
          i++;
        }

        print();
      }
    }else{
      for (var i = 0; i < length;) {

        LODOP.SET_PRINT_PAGESIZE(1, 990, 700, "strPageName"); //设置纸张大小
        LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE", 1); //设置非逐项打印
        LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true); //设置输出以纸张边缘为基点
        
        //以下内容画矩形，用以标注标签范围，便于软件开发
        //ADD_PRINT_RECT(Top, Left, Width, Height,intLineStyle, intLineWidth)
        //LODOP.ADD_PRINT_RECT(top, left, maxWidth, maxHeight,0, 1);//标注标签范围
        //LODOP.ADD_PRINT_RECT(top,left+20,maxWidth-40,rowSpacing,0, 3);//标注标题及单行高度
  
        if(i==length-1){
          /* LODOP.ADD_PRINT_TEXT(top + rowSpacing * 1, left+20, fontWidth, rowSpacing, "存根");
          LODOP.ADD_PRINT_BARCODE(top + rowSpacing * 2, left+20, 100, 100, "QRCode", lableUrl + ids[i]);
          i++; */

          LODOP.SET_PRINT_STYLE("FontSize", 8); //设置打印字体
          //LODOP.SET_PRINT_STYLE("FontName","仿宋"); //设置打印字体
          LODOP.SET_PRINT_STYLE("Bold", 1); //设置打印字体
          /*
          * 设置第一列内容
          */
          // 文本格式 - ADD_PRINT_TEXT(Top,Left,Width,Height,strContent)
          LODOP.ADD_PRINT_TEXT(top - 10, leftTitle, fontWidth, rowSpacing, array[0]+"（存根）"); //title
    
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9); //设置打印字体
    
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 1, left, fontWidth, rowSpacing, "追溯码：" + ids[i]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 2, left, fontWidth, rowSpacing, "追溯码查询方式：" + array[3]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 3, left, fontWidth, rowSpacing, "查询网站：http://www.grncp.cn/");
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 4, left, fontWidth, rowSpacing, "包装规格：" + array[15]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 5, left, fontWidth, rowSpacing, "产品名称：" + array[4]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 6, left, fontWidth, rowSpacing, "产品标准：" + array[6]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 7, left, fontWidth, rowSpacing, "产品等级：" + array[5]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 8, left, fontWidth, rowSpacing, "产品认证：" + array[7]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 9, left, fontWidth, rowSpacing, "采摘日期：:" + array[13]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 10, left, fontWidth, rowSpacing, "包装日期：:" + array[8]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 11, left, fontWidth, rowSpacing, "保质期：" + array[9] + "天");
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 12, left, fontWidth, rowSpacing, "检测结果："+array[18]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 13, left, fontWidth, rowSpacing, array[10]);//公司名称
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 14, left, fontWidth, rowSpacing, "联系电话：" + array[11]);//
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 15, left, fontWidth, rowSpacing, array[12]);//公司地址
          // 二维码格式 - ADD_PRINT_BARCODE(Top, Left,Width, Height, CodeType, CodeValue)
          LODOP.ADD_PRINT_BARCODE(QRCodeTop, QRCodeLeft, QRCodeLength, QRCodeLength, "QRCode", lableUrl + ids[i]);//二维码
          //  LODOP.SET_PRINT_STYLEA(0,"QRCodeVersion",14);//设置二维码类型
          LODOP.ADD_PRINT_BARCODE(BARTop, BARLeft, BARWidth, BARHeight, BARType, ids[i]);//条形码
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6); //设置条形码字体
    
          LODOP.ADD_PRINT_TEXT(BARTop + BARHeight + 6, QRCodeLeft, 100, rowSpacing, "重量：" + array[17] );//净重量
		  
    
          //  PSKPrn.PTKDrawBarcode(590, 350, 0, '1', 2, 2, 50, 66, ids[i]);  //N的ASCII码是78，B的ASCII码是66
          i++;
        }else{
          LODOP.SET_PRINT_STYLE("FontSize", 8); //设置打印字体
          //LODOP.SET_PRINT_STYLE("FontName","仿宋"); //设置打印字体
          LODOP.SET_PRINT_STYLE("Bold", 1); //设置打印字体
          /*
          * 设置第一列内容
          */
          // 文本格式 - ADD_PRINT_TEXT(Top,Left,Width,Height,strContent)
          LODOP.ADD_PRINT_TEXT(top - 10, leftTitle, fontWidth, rowSpacing, array[0]); //title
    
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9); //设置打印字体
    
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 1, left, fontWidth, rowSpacing, "追溯码：" + ids[i]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 2, left, fontWidth, rowSpacing, "追溯码查询方式：" + array[3]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 3, left, fontWidth, rowSpacing, "查询网站：http://www.grncp.cn/");
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 4, left, fontWidth, rowSpacing, "包装规格：" + array[15]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 5, left, fontWidth, rowSpacing, "产品名称：" + array[4]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 6, left, fontWidth, rowSpacing, "产品标准：" + array[6]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 7, left, fontWidth, rowSpacing, "产品等级：" + array[5]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 8, left, fontWidth, rowSpacing, "产品认证：" + array[7]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 9, left, fontWidth, rowSpacing, "采摘日期：:" + array[13]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 10, left, fontWidth, rowSpacing, "包装日期：:" + array[8]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 11, left, fontWidth, rowSpacing, "保质期：" + array[9] + "天");
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 12, left, fontWidth, rowSpacing, "检测结果："+array[18]);
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 13, left, fontWidth, rowSpacing, array[10]);//公司名称
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 14, left, fontWidth, rowSpacing, "联系电话：" + array[11]);//
          LODOP.ADD_PRINT_TEXT(top + rowSpacing * 15, left, fontWidth, rowSpacing, array[12]);//公司地址
          // 二维码格式 - ADD_PRINT_BARCODE(Top, Left,Width, Height, CodeType, CodeValue)
          LODOP.ADD_PRINT_BARCODE(QRCodeTop, QRCodeLeft, QRCodeLength, QRCodeLength, "QRCode", QRCodeUrl + ids[i]);//二维码
          //  LODOP.SET_PRINT_STYLEA(0,"QRCodeVersion",14);//设置二维码类型
          LODOP.ADD_PRINT_BARCODE(BARTop, BARLeft, BARWidth, BARHeight, BARType, ids[i]);//条形码
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6); //设置条形码字体
    
          LODOP.ADD_PRINT_TEXT(BARTop + BARHeight + 6, QRCodeLeft, 100, rowSpacing, "重量：" + array[14] );//净重量
    
          //  PSKPrn.PTKDrawBarcode(590, 350, 0, '1', 2, 2, 50, 66, ids[i]);  //N的ASCII码是78，B的ASCII码是66
          i++;
        }
  
        print();
      }
    }
  }

  //去掉后期加入的pkid并修改长度值，防止打印多次导致出错
  ids.pop();
  length=length-1;
  
  //alert('请等待打印完成');
  //layer.close(layer_load);
  $('body').mLoading("hide");
  
});

/**
 * 读取选中的打印机并打印
 */
function print() {
  LODOP.SET_PRINTER_INDEX($("#printers").val()); //设置选择的打印机

  //var isPrint = LODOP.PRINT(); //打印
  //LODOP.PREVIEW();

  //LODOP.PRINT_DESIGN();
  //return;
  //console.log(isPrint);
  
  printTimes++;
  
  //if (printTimes == 1) {
  //  alert("共需要打印" + printTimes + "次，" + length + "个标签\r\n请耐心等待标签打印完毕后关闭打印窗口");

 // }
  //防治多次打印时，打印预览太多或者只能打印一张，增加一个判断逻辑
  if (printTimes == 1) {
    //LODOP.PREVIEW();//第一次使用打印预览
	LODOP.PRINT();
  } else {
    LODOP.PRINT();//其余直接打印
  }
  
}

function isBlankStr(str){
	if (typeof(str) == "undefined" || str == null || str == "" || str=="none" || str=="null") {
		return true;
	} else {
		return false;
	}
}

function printStr(str){
  if(isBlankStr(str)){
    return '';
  }else{
    return str;
  }
}

var CreatedOKLodop7766 = null, CLodopIsLocal;

//====判断是否需要 Web打印服务CLodop:===
//===(不支持插件的浏览器版本需要用它)===
function needCLodop() {
    try {
        var ua = navigator.userAgent;
        if (ua.match(/Windows\sPhone/i))
            return true;
        if (ua.match(/iPhone|iPod|iPad/i))
            return true;
        if (ua.match(/Android/i))
            return true;
        if (ua.match(/Edge\D?\d+/i))
            return true;

        var verTrident = ua.match(/Trident\D?\d+/i);
        var verIE = ua.match(/MSIE\D?\d+/i);
        var verOPR = ua.match(/OPR\D?\d+/i);
        var verFF = ua.match(/Firefox\D?\d+/i);
        var x64 = ua.match(/x64/i);
        if ((!verTrident) && (!verIE) && (x64))
            return true;
        else if (verFF) {
            verFF = verFF[0].match(/\d+/);
            if ((verFF[0] >= 41) || (x64))
                return true;
        } else if (verOPR) {
            verOPR = verOPR[0].match(/\d+/);
            if (verOPR[0] >= 32)
                return true;
        } else if ((!verTrident) && (!verIE)) {
            var verChrome = ua.match(/Chrome\D?\d+/i);
            if (verChrome) {
                verChrome = verChrome[0].match(/\d+/);
                if (verChrome[0] >= 41)
                    return true;
            }
        }
        return false;
    } catch (err) {
        return true;
    }
}

//====页面引用CLodop云打印必须的JS文件,用双端口(8000和18000）避免其中某个被占用：====
if (needCLodop()) {
    var src1 = "http://localhost:8000/CLodopfuncs.js?priority=1";
    var src2 = "http://localhost:18000/CLodopfuncs.js?priority=0";

    var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
    var oscript = document.createElement("script");
    oscript.src = src1;
    head.insertBefore(oscript, head.firstChild);
    oscript = document.createElement("script");
    oscript.src = src2;
    head.insertBefore(oscript, head.firstChild);
    CLodopIsLocal = !!((src1 + src2).match(/\/\/localho|\/\/127.0.0./i));
}

//====获取LODOP对象的主过程：====
function getLodop(oOBJECT, oEMBED) {
    var strHtmInstall = "<br><font>打印功能已经升级!点击这里<a href='install_lodop32.exe' target='_self'>执行安装</a><br>安装完成后关闭并重新打开浏览器。</font>";
    var strHtmUpdate = "<br><font>打印功能已经升级!点击这里<a href='install_lodop32.exe' target='_self'>执行升级</a><br>安装完成后关闭并重新打开浏览器。</font>";
    var strHtm64_Install = "<br><font>打印功能已经升级!点击这里<a href='install_lodop64.zip' target='_self'>执行安装</a><br>安装完成后关闭并重新打开浏览器。</font>";
    var strHtm64_Update = "<br><font>打印控件需要升级!点击这里<a href='install_lodop64.zip' target='_self'>执行升级</a><br>安装完成后关闭并重新打开浏览器。</font>";
    var strHtmFireFox = "<br><br><font>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>";
    var strHtmChrome = "<br><br><font>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>";
    var strCLodopInstall_1 = "<br><font>打印功能已经升级，点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>下载执行安装</a>";
    var strCLodopInstall_2 = "<br>（若此前已安装过，可<a href='CLodop.protocol:setup' target='_self'>点这里直接再次启动</a>）";
    var strCLodopInstall_3 = "<br>安装完成后关闭并重新打开浏览器。</font>";
    var strCLodopUpdate = "<br><font>打印功能已经升级!点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>执行升级</a>,安装完成后关闭并重新打开浏览器。</font>";
    var LODOP;
    try {
        var ua = navigator.userAgent;
        var isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i));
        if (needCLodop()) {
            try {
                LODOP = getCLodop();

            } catch (err) {}
            if (!LODOP && document.readyState !== "complete") {
                return;
            }
            if (!LODOP) {
                document.getElementById("printInfo").innerHTML = strCLodopInstall_1 + strCLodopInstall_3 + document.getElementById("printInfo").innerHTML;
                return;
            } else {
                if (CLODOP.CVERSION < "3.0.6.0") {
                    document.getElementById("printInfo").innerHTML = strCLodopUpdate + document.getElementById("printInfo").innerHTML;
                }
                if (oEMBED && oEMBED.parentNode)
                    oEMBED.parentNode.removeChild(oEMBED);
                if (oOBJECT && oOBJECT.parentNode)
                    oOBJECT.parentNode.removeChild(oOBJECT);
            }
        } else {
            var is64IE = isIE && !!(ua.match(/x64/i));
            //=====如果页面有Lodop就直接使用，没有则新建:==========
            if (oOBJECT || oEMBED) {
                if (isIE)
                    LODOP = oOBJECT;
                else
                    LODOP = oEMBED;
            } else if (!CreatedOKLodop7766) {
                LODOP = document.createElement("object");
                LODOP.setAttribute("width", 0);
                LODOP.setAttribute("height", 0);
                LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;");
                if (isIE)
                    LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA");
                else
                    LODOP.setAttribute("type", "application/x-print-lodop");
                document.documentElement.appendChild(LODOP);
                CreatedOKLodop7766 = LODOP;
            } else
                LODOP = CreatedOKLodop7766;
            //=====Lodop插件未安装时提示下载地址:==========
            if ((!LODOP) || (!LODOP.VERSION)) {
                if (ua.indexOf('Chrome') >= 0)
                    document.getElementById("printInfo").innerHTML = strHtmChrome + document.getElementById("printInfo").innerHTML;
                if (ua.indexOf('Firefox') >= 0)
                    document.getElementById("printInfo").innerHTML = strHtmFireFox + document.getElementById("printInfo").innerHTML;
                document.getElementById("printInfo").innerHTML = (is64IE ? strHtm64_Install : strHtmInstall) + document.getElementById("printInfo").innerHTML;
                return LODOP;
            }
        }
        if (LODOP.VERSION < "6.2.2.4") {
            if (!needCLodop())
                document.getElementById("printInfo").innerHTML = (is64IE ? strHtm64_Update : strHtmUpdate) + document.getElementById("printInfo").innerHTML;
            return LODOP;
        }
        //===如下空白位置适合调用统一功能(如注册语句、语言选择等):==
        LODOP.SET_LICENSES("","AF20A0AF2A03FCCD6AC033847CFB0152","C94CEE276DB2187AE6B65D56B3FC2848","");


        //LODOP.SET_LICENSES("","13528A153BAEE3A0254B9507DCDE2839","","");
        //=======================================================
        return LODOP;
    } catch (err) {
        alert("getLodop出错:" + err);
    }
}
